export default __webpack_public_path__ + "static/media/07.579b61d0.jpg";